import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import AmountCalculationTable from './AmountCalculationTable';
import { addOutline, closeCircleOutline, pencilOutline, saveOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import ModalPopup from '@ui/components/VnModal';
import AddQuotationAmountForm from './AddQuotationAmountForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getAllQuotationAmountsAsync, updateBulkQuotationAmountAsync } from '@application/features/quotations/quotationThunk';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import QuotationAmountTable from './QuotationAmountTable';
import { handleRolePermission } from '@infrastructure/helpers';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
import { addErrorNotification } from '@application/features/common/notificationSlice';
const AmountCalculationTab = ({ formData, errors, onFieldChange, onCalendarChange, isAmountCalculationTabBold }) => {
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState(null);
    const { QuotationAmounts, SelectedWorkorderCalculationsItemIdsList } = useAppSelector((state) => state.quotation);
    const [isQuotationSelectionTableOpen, setIsQuotationSelectionTableOpen] = useState(false);
    const navigate = useNavigate();
    const onAddAmountClick = () => {
        setIsOpen(true);
    };
    const { id } = useParams();
    const onAddAmountCloseClicked = () => {
        setIsOpen(false);
    };
    /*Inline Editing Region*/
    useEffect(() => {
        appendDataintoEdit();
    }, [QuotationAmounts]);
    async function onEdit() {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setIsEditing(true);
        }
    }
    function onSave() {
        if (editedData) {
            const updatedData = editedData.map((item) => ({
                ...item,
                price: item.price === '' ? 0 : item.price,
                quantity: item.quantity === '' ? 0 : item.quantity
            }));
            dispatch(updateBulkQuotationAmountAsync(updatedData)).then(() => {
                dispatch(getAllQuotationAmountsAsync(parseInt(id)));
                setIsEditing(false);
                setEditedData(null);
            });
        }
        setIsEditing(false);
    }
    function onCancel() {
        setIsEditing(false);
        appendDataintoEdit();
    }
    function appendDataintoEdit() {
        if (QuotationAmounts) {
            setEditedData((data) => {
                const updatedData = QuotationAmounts.map((quotationAmount) => ({ ...quotationAmount }));
                return updatedData;
            });
        }
    }
    function onEditData(data) {
        setEditedData(data);
    }
    /*Inline Editing Region End*/
    /* Copying Quotation to Invoice Region Start*/
    // const handleQuotationSelectionTableClose = () => {
    //     setIsQuotationSelectionTableOpen(false);
    // };
    // const handleSelectedQuotationSubmit = (selectedQuotations: QuotationAmountDto[]) => {
    //      if (formData.workorderNumber && formData.workOrderId) {
    //         const workOrderData: LabelValueDto = {
    //             label: formData.workorderNumber,
    //             value: formData.workOrderId
    //         };
    //          dispatch(setInvoiceWorkOrderNumber(workOrderData));
    //          dispatch(setSelectedQuotationItemsListForInvoice(selectedQuotations));
    //          navigate(`/admin/InvoiceTabs`);
    //         }
    //      setIsQuotationSelectionTableOpen(false);
    // };
    // const handleTransferToInvoiceClick=()=>{
    //     if (formData.workorderNumber && formData.workOrderId) {
    //         const workOrderData: LabelValueDto = {
    //             label: formData.workorderNumber,
    //             value: formData.workOrderId
    //         };
    //          dispatch(setInvoiceWorkOrderNumber(workOrderData));
    //          dispatch(setSelectedQuotationItemsListForInvoice(QuotationAmounts));
    //          navigate(`/admin/InvoiceTabs`);
    //         }
    // }
    const cleanupInoviceTransferDataLocalStorageEntries = () => {
        const now = Date.now();
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('invoiceTransfer_')) {
                const data = JSON.parse(localStorage.getItem(key));
                if (now - data.timestamp > 3600000) { // 1 hour
                    localStorage.removeItem(key);
                }
            }
        });
    };
    const handleTransferToInvoiceClick = () => {
        if (formData.workorderNumber && formData.workOrderId && QuotationAmounts) {
            cleanupInoviceTransferDataLocalStorageEntries();
            const dataKey = `invoiceTransfer_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            const transferData = {
                workOrderData: {
                    label: formData.workorderNumber,
                    value: formData.workOrderId
                },
                quotationAmounts: QuotationAmounts,
                timestamp: Date.now()
            };
            try {
                localStorage.setItem(dataKey, JSON.stringify(transferData));
                const url = `/admin/InvoiceTabs?dataKey=${encodeURIComponent(dataKey)}`;
                window.open(url, '_blank');
            }
            catch (error) {
                console.error('Failed to store invoice data:', error);
                dispatch(addErrorNotification('Kon factuurgegevens niet opslaan'));
            }
        }
        else {
            dispatch(addErrorNotification('Ontbrekende gegevens voor factuuradministratie'));
        }
    };
    /* Copying Quotation to Invoice Region End*/
    //--------------------Module Lock-------------------------------------------
    const checkModulelock = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Offertes,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData)).unwrap();
                if (res.isModuleAlreadyLocked) {
                    dispatch(setModuleLock());
                    return true;
                }
                dispatch(unsetModuleLock());
                return false;
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'vn-Material-Add-buttons', children: [isEditing && (_jsxs(_Fragment, { children: [_jsx(VnButton, { icon: closeCircleOutline, customClassName: 'vn-action-button vn-inline-editing-action-button', mode: 'danger', size: 'sm', isDisabled: id ? false : true, customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon', onClick: () => {
                                    onCancel();
                                } }), _jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button vn-inline-editing-action-button mr-14', mode: 'primary', size: 'sm', onClick: () => {
                                    onSave();
                                }, type: 'submit', customIconClassName: 'vn-action-button-icon vn-inline-editing-action-button-icon' })] })), !isEditing && QuotationAmounts && id && (_jsx(VnButton, { icon: pencilOutline, customClassName: 'vn-action-button-cancel vn-inline-editing-action-button mr-14', mode: 'secondary', size: 'sm', customIconClassName: 'vn-action-button-cancel-icon vn-inline-editing-action-button-icon', onClick: () => {
                            onEdit();
                        }, isDisabled: !handleRolePermission(Permission.OFFERTE, PermissionType.Update) })), _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-1 mb-3 mr-14', icon: addOutline, isDisabled: handleRolePermission(Permission.OFFERTE, PermissionType.Create) && id ? false : true, 
                        //onClick={() => setIsQuotationSelectionTableOpen(true)}
                        onClick: async () => {
                            var moduleLockStatus = await checkModulelock();
                            if (moduleLockStatus == false) {
                                handleTransferToInvoiceClick();
                            }
                        }, children: "Offerte overnemen naar factuur" }), id && (_jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-1 mb-3', icon: addOutline, isDisabled: handleRolePermission(Permission.OFFERTE, PermissionType.Create) && id ? false : true, onClick: async () => {
                            var moduleLockStatus = await checkModulelock();
                            if (moduleLockStatus == false) {
                                onAddAmountClick();
                            }
                        }, children: "Regel toevoegen" }))] }), formData.workOrderId && !id ? (_jsx(QuotationAmountTable, { formData: formData, onFieldChange: onFieldChange, selectedWorkorderCalculations: SelectedWorkorderCalculationsItemIdsList, isAmountCalculationTabBold: isAmountCalculationTabBold })) : (_jsx(AmountCalculationTable, { isEditing: isEditing, editedData: editedData, editData: onEditData, isAmountCalculationTabBold: isAmountCalculationTabBold })), _jsx(ModalPopup, { title: 'Toevoegen Bedrag', content: _jsx(AddQuotationAmountForm, { onClose: () => onAddAmountCloseClicked(), isAmountCalculationTabBold: isAmountCalculationTabBold }), onOpen: isOpen, onClose: () => onAddAmountCloseClicked(), modalWidth: 'lg' })] }));
};
export default AmountCalculationTab;
